import React from 'react';

import { flagStyles } from '../settings';

const SvgVA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5568px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgVA;
